/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class FlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }

  show(flowId) {
    return axios.get(`${this.url}/${flowId}`);
  }

  create(payload) {
    return axios.post(this.url, payload);
  }

  update(flowId, payload) {
    return axios.patch(`${this.url}/${flowId}`, { flow: payload });
  }

  saveDefinition(
    flowId,
    draftDefinition,
    executionSettings,
    etag,
    draftTriggers,
    extraFields = {}
  ) {
    return axios.patch(
      `${this.url}/${flowId}`,
      {
        flow: {
          ...extraFields,
          draft_definition: draftDefinition,
          execution_settings: executionSettings,
          ...(draftTriggers !== undefined && { draft_triggers: draftTriggers }),
        },
      },
      { headers: { 'If-Match': `"${etag}"` } }
    );
  }

  destroy(flowId) {
    return axios.delete(`${this.url}/${flowId}`);
  }

  publish(flowId) {
    return axios.post(`${this.url}/${flowId}/publish`);
  }

  pause(flowId) {
    return axios.post(`${this.url}/${flowId}/pause`);
  }

  cancelRuns(flowId) {
    return axios.post(`${this.url}/${flowId}/cancel_runs`);
  }
}

export default new FlowsAPI();
